import { SsnDuplicateModal } from 'src/components/features/GlobalModals/modals/SsnDuplicateModal';
import { useModalStore } from 'src/store/modalStore';

export const GlobalModals = () => {
  const { ssnDuplicate } = useModalStore(state => state.modals);

  const handleDuplicateSsnButtonClick = () => {
    ssnDuplicate.setIsOpen(false);
  };

  return (
    <>
      <SsnDuplicateModal
        modalError={ssnDuplicate.isOpen}
        setModalError={ssnDuplicate.setIsOpen}
        modalButtonText={'Verify income info'}
        handleModalButtonClick={handleDuplicateSsnButtonClick}
      />
    </>
  );
};
